export default __webpack_public_path__ + "static/media/Group.535a0faf.svg";